"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("./messages");
/**
 * A service which provides localization methods.
 */
var LocalizationService = /** @class */ (function () {
    function LocalizationService(language) {
        this.language = language;
        if (language === '' && process.env.NODE_ENV !== 'production') {
            throw 'Language should not be an empty string';
        }
    }
    // tslint:disable:max-line-length
    /**
     * Provides a string based on a key for the current language. When no string for the current language is available under this key, the `defaultValue` is returned.
     *
     * @param key - The key which identifies the string for the current language.
     * @param defaultValue - The default value which will be returned when no string
     * for the current language is available under the key.
     * @return - The string for the current language.
     */
    // tslint:enable:max-line-length
    LocalizationService.prototype.toLanguageString = function (key, defaultValue) {
        if (this.language &&
            messages_1.messages[this.language] &&
            messages_1.messages[this.language].hasOwnProperty(key)) {
            return messages_1.messages[this.language][key];
        }
        else {
            return defaultValue;
        }
    };
    return LocalizationService;
}());
exports.LocalizationService = LocalizationService;
//# sourceMappingURL=LocalizationService.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/Localization/LocalizationService.js
// module id = 128
// module chunks = 0